export default __webpack_public_path__ + "static/media/iptracker.8f1ba43e.PNG";